import { StorageUsage } from './StorageUsage'
import { withStorageUsage } from './withStorageUsage'

const ConnectedStorageUsage = withStorageUsage(StorageUsage)
export { ConnectedStorageUsage as StorageUsage }
